import React from "react";
import { MatchData } from "../../types/match.types";

interface MapSelectorProps {
	matches: MatchData[];
	selectedMapIndex: number;
	onMapChange: (index: number) => void;
	seriesScore: {
		headerTeam1: number;
		headerTeam2: number;
	};
	mapScoreToHeaderOrder: (match: MatchData) => {
		headerTeam1Score: number;
		headerTeam2Score: number;
	};
}

const MapSelector: React.FC<MapSelectorProps> = ({
	matches,
	selectedMapIndex,
	onMapChange,
	seriesScore,
	mapScoreToHeaderOrder,
}) => {
	if (matches.length <= 1) {
		return null;
	}

	return (
		<div className="series-header">
			<div className="map-selector">
				{/* Total Button */}
				<button
					className={`map-button ${selectedMapIndex === -1 ? "active" : ""}`}
					onClick={() => onMapChange(-1)}
				>
					TOTAL: {seriesScore.headerTeam1}-{seriesScore.headerTeam2}
				</button>

				{/* Individual Map Buttons */}
				{matches.map((m, index) => {
					const mappedScore = mapScoreToHeaderOrder(m);
					const mapName = m.mapName.replace("de_", "").toUpperCase();
					// Truncate map name if too long
					const displayName = mapName.length > 5 ? mapName.substring(0, 3) : mapName;
					return (
						<button
							key={index}
							className={`map-button ${
								index === selectedMapIndex ? "active" : ""
							}`}
							onClick={() => onMapChange(index)}
						>
							{displayName}: {mappedScore.headerTeam1Score}-{mappedScore.headerTeam2Score}
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default MapSelector;